import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSetting, settings, subscribeSetting } from '../core/settings/settings';
import { en } from './en';
import { fi } from './fi';

// The new UI's translations. The language setting is the source of truth:
// changing it (here or in another tab) switches the language and <html lang>.
void i18next
    .use(initReactI18next)
    .init({
        resources: { en: { translation: en }, fi: { translation: fi } },
        lng: getSetting(settings.language),
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
        returnNull: false,
    });

const applyLanguage = () => {
    const language = getSetting(settings.language);
    document.documentElement.lang = language;
    if (i18next.language !== language) {
        void i18next.changeLanguage(language);
    }
};

applyLanguage();
subscribeSetting(settings.language, applyLanguage);

export default i18next;
